import "./Permissions.scss";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const isPathActive = (path) => {
  return window.location.pathname.startsWith(path);
};

function Permissions(props) {
  const { t } = useTranslation();

  const userPermissions = useMemo(() =>
    JSON.parse(localStorage.getItem("permissions"))
  );

  return (
    userPermissions &&
    userPermissions.map(
      (e, i) =>
        props.menu === e.menu &&
        e.view === 1 && (
          <li
            key={"menu_" + e.id}
            className={
              isPathActive(props.linkTo)
                ? "nav-item menu-items active"
                : "nav-item menu-items"
            }
          >
            <Link className="nav-link" to={props.linkTo}>
              <span className="menu-icon">
                <i className={props.icone}></i>
              </span>
              <span className="menu-title">{t(props.trans)}</span>
            </Link>
          </li>
        )
    )
  );
}

export default Permissions;
